import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import { ProductList } from '../components/product_list'
import Themed from 'store/v2/react/components/Themed'

const store = window.booqableStore

export class List extends React.Component {
  static displayName = 'ListContainer'

  static propTypes = {
    searchKey: PropTypes.string
  }

  render = () => {
    return (
      <Provider store={store}>
        <Themed>
          <div className="booqable-component" style={{ display: 'none' }}>
            <ProductList {...this.props} filterKey={this.props.searchKey} />
          </div>
        </Themed>
      </Provider>
    )
  }
}
